
import React from "react";
import Header from "../../../components/header/Header";

import projetPokemon from "../../../files/pokemon.jpg";
/* import projetAutoNexus from "../../../files/autonexus.png";
 */import projetCinescope from "../../../files/cinescope.png";
 import projetBuildTogether from "../../../files/buildtogether.png"

const projects = [
  {
    id: "pokemon",
    title: "PokéWarm",
    status: "✅ Projet terminé",
    statusColor: "#08110b",
    statusBg: "rgba(34,197,94,.15)",

    category:
      "Application web dédiée à l'univers Pokémon.",

    description:
      "PokéWarm est une application web permettant d'explorer les Pokémon et leurs caractéristiques à partir de données récupérées directement depuis une API.",

    features: [
      "Catalogue de Pokémon",
      "Recherche des Pokémon",
      "Filtres",
      "Pagination",
      "Fiche détaillée",
      "Évolutions",
      "Dresseurs"
    ],

    technologies: [
      "React",
      "JavaScript",
      "API",
      "CSS"
    ],

    objective:
      "Créer une interface simple et interactive permettant d'explorer les données Pokémon récupérées depuis une API.",

    badges: [
      "✅ Terminé",
      "⚡ Pokémon",
      "🌐 API",
      "🔎 Recherche",
      "🎯 Filtres",
      "🔄 Évolutions",
      "👤 Dresseurs"
    ],

    image: projetPokemon,

    link: "https://pokewarm.maheriarimanana.com/"
  },

  

{
  id: "cinescope",
  title: "CinéScope",
  status: "🚧 En développement",
  statusColor: "#ff8800",
  statusBg: "rgba(251,15,15,.15)",

  category:
    "Plateforme web fullstack dédiée à la découverte, à l'exploration et au partage autour du cinéma international.",

  description:
    "CinéScope est une plateforme web fullstack qui s'appuie sur l'API TMDB pour récupérer les données de films et de séries. Elle permet aux utilisateurs d'explorer, rechercher et découvrir des œuvres cinématographiques du monde entier, tout en proposant des actualités, un calendrier des festivals et évènements, ainsi qu'un espace de réseau social.",

  features: [
    "Catalogue de films et séries",
    "Recherche",
    "Filtres & Pagination",
    "Fiches détaillées",
    "Actualités cinéma",
    "Calendrier des festivals et évènements",
    "Bandes-annonces",
    "Réseau social"
  ],

  technologies: [
    "React",
    "JavaScript",
    "Node.js",
    "Express",
    "MongoDB",
    "Mongoose",
    "TMDB API",
    "CSS"
  ],

  objective:
    "Créer une plateforme cinématographique complète permettant de découvrir des films et des séries internationaux, de suivre l'actualité du cinéma et de favoriser les échanges entre passionnés.",

  badges: [
    "🚧 En développement",
    "🎬 Cinéma",
    "🌐 TMDB API",
    "🔎 Recherche",
    "🎯 Filtres",
    "🌍 International",
    "🎞️ Films",
    "📺 Séries"
  ],

  image: projetCinescope
},


{
  id: "buildtogether",
  title: "BuildTogether",
  status: "📝 En conception",
  statusColor: "#8b5cf6",
  statusBg: "rgba(139,92,246,.15)",

  category:
    "Plateforme web fullstack collaborative dédiée à la mise en relation des talents et à la réalisation de projets collectifs.",

  description:
    "BuildTogether est une plateforme web fullstack qui permet aux étudiants, développeurs, designers, créateurs et porteurs d'idées de trouver des collaborateurs partageant leurs intérêts et leurs compétences. Les utilisateurs peuvent publier des projets, rechercher des profils, rejoindre des équipes, organiser les tâches et suivre l'avancement de leurs réalisations. L'objectif est de transformer les idées individuelles en projets concrets grâce à la collaboration.",

  features: [
    "Inscription et authentification sécurisée",
    "Profils utilisateurs et compétences",
    "Publication et découverte de projets",
    "Recherche et filtres avancés",
    "Candidatures pour rejoindre des projets",
    "Création et gestion des équipes",
    "Gestion des tâches et des jalons",
    "Suivi de la progression des projets",
    "Échanges entre collaborateurs",
    "Portfolio des réalisations"
  ],

  technologies: [
    "React",
    "JavaScript",
    "Node.js",
    "Express",
    "MongoDB",
    "Mongoose",
    "JWT",
    "CSS"
  ],

  objective:
    "Créer une plateforme collaborative internationale permettant aux étudiants, jeunes professionnels et créateurs de trouver les bons partenaires, de développer leurs compétences et de concrétiser des projets au sein d'équipes multidisciplinaires.",

  badges: [
    "📝 En conception",
    "🤝 Collaboration",
    "🌐 International",
    "💡 Innovation",
    "👥 Communauté",
    "🛠️ Gestion de projets",
    "🎯 Compétences",
    "🚀 Réalisations"
  ],

  image: projetBuildTogether
},

 
/* 
  {
    id: "autonexus",
    title: "AutoNexus",
    status: "📝 En conception",
    statusColor: "#fb0f0f",
    statusBg: "rgba(251,15,15,.15)",

    category:
      "Plateforme Full Stack de vente automobile et de mise en relation entre clients et concessionnaires.",

    description:
      "AutoNexus est une plateforme web dédiée aux concessionnaires automobiles, conçue pour digitaliser la commercialisation des véhicules, optimiser la gestion des stocks et faciliter les échanges avec les acheteurs.",

    features: [
      "Authentification et gestion des rôles",
      "Gestion des concessionnaires et des véhicules",
      "Catalogue automobile et recherche multicritère",
      "Fiches détaillées et comparateur de véhicules",
      "Demandes de contact, rendez-vous et suivi des prospects",
      "Tableau de bord concessionnaire et statistiques"
    ],

    technologies: [
      "React",
      "Node.js",
      "Express",
      "MongoDB",
      "JWT"
    ],

    objective:
      "Créer une plateforme automobile professionnelle permettant aux concessionnaires de gérer leur stock, de promouvoir leurs véhicules et de suivre leurs opportunités commerciales, tout en simplifiant la recherche et la prise de contact pour les acheteurs.",

    badges: [
      "📝 En conception",
      "🚗 Vente automobile",
      "🏢 Concessionnaires",
      "🔎 Recherche avancée",
      "⚖️ Comparateur",
      "📊 Gestion commerciale"
    ],

    image: projetAutoNexus
  } */
];

const Projets = () => {
  const styles = {
    page: {
      minHeight: "100vh",
      width: "100%",
      backgroundColor: "#0f2027",
      color: "#fff",
      fontFamily: "Poppins, sans-serif",
      overflowX: "hidden"
    },

    main: {
      width: "100%",
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "140px 20px 70px",
      boxSizing: "border-box",
            backgroundColor: "#0f2027",

    },

    header: {
      width: "100%",
      textAlign: "center",
      marginBottom: "50px"
    },

    title: {
      margin: "0 0 15px",
      fontSize: "clamp(32px, 5vw, 42px)",
      lineHeight: "1.15",
      fontWeight: "800"
    },

    subtitle: {
      width: "100%",
      maxWidth: "750px",
      margin: "0 auto",
      color: "#cbd5e1",
      fontSize: "clamp(15px, 2vw, 18px)",
      lineHeight: "1.6"
    },

    line: {
      width: "80px",
      height: "4px",
      margin: "25px auto 0",
      background: "#ffd700",
      borderRadius: "5px"
    },

    grid: {
      width: "100%",
      display: "grid",

      /*
       * Auto-fit permet au navigateur de choisir automatiquement
       * le nombre de colonnes disponible.
       *
       * Grand écran  → 2 colonnes
       * Tablette     → 2 ou 1 colonne selon la largeur
       * Mobile       → 1 colonne
       */
      gridTemplateColumns:
        "repeat(auto-fit, minmax(min(100%, 480px), 1fr))",

      gap: "30px",
      alignItems: "stretch"
    },

    card: {
      minWidth: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      background: "rgba(255,255,255,.05)",
      border: "1px solid rgba(255,255,255,.15)",
      borderRadius: "20px",
      boxShadow: "0 15px 35px rgba(0,0,0,.35)",
      boxSizing: "border-box"
    },

    imageBox: {
      position: "relative",
      width: "100%",
      height: "clamp(450px, 22vw, 350px)",
      minHeight: "180px",
      overflow: "hidden",
      flexShrink: 0
    },

    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block"
    },

    body: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minWidth: 0,
      padding: "25px",
      boxSizing: "border-box"
    },

    titleCard: {
      margin: "0 0 10px",
      fontSize: "clamp(23px, 3vw, 27px)",
      lineHeight: "1.2",
      overflowWrap: "break-word"
    },

    category: {
      margin: "0 0 15px",
      color: "#ffd700",
      fontSize: "14px",
      lineHeight: "1.5",
      fontWeight: "600",
      overflowWrap: "break-word"
    },

    description: {
      margin: "0 0 20px",
      color: "#e2e8f0",
      fontSize: "14px",
      lineHeight: "1.6",
      overflowWrap: "break-word"
    },

    badges: {
      display: "flex",
      flexWrap: "wrap",
      gap: "7px",
      marginBottom: "20px"
    },

    badge: {
      maxWidth: "100%",
      padding: "5px 10px",
      border: "1px solid rgba(255,255,255,.2)",
      borderRadius: "15px",
      background: "rgba(255,255,255,.08)",
      color: "#f1f5f9",
      fontSize: "11px",
      lineHeight: "1.4",
      boxSizing: "border-box",
      overflowWrap: "break-word"
    },

    section: {
      margin: "0 0 8px",
      fontSize: "14px",
      lineHeight: "1.4"
    },

    list: {
      margin: "0 0 20px",
      paddingLeft: "18px",
      color: "#cbd5e1",
      fontSize: "13px",
      lineHeight: "1.6",
      overflowWrap: "break-word"
    },

    techs: {
      display: "flex",
      flexWrap: "wrap",
      gap: "7px",
      marginBottom: "20px"
    },

    tech: {
      padding: "5px 10px",
      border: "1px solid rgba(255,255,255,.2)",
      borderRadius: "6px",
      background: "rgba(255,255,255,.08)",
      fontSize: "11px",
      lineHeight: "1.4"
    },

    objective: {
      marginBottom: "20px",
      padding: "12px",
      borderLeft: "3px solid #ffd700",
      background: "rgba(255,215,0,.08)",
      borderRadius: "0 8px 8px 0",
      boxSizing: "border-box"
    },

    objectiveTitle: {
      display: "block",
      marginBottom: "3px",
      color: "#ffd700",
      fontSize: "12px",
      fontWeight: "600"
    },

    objectiveText: {
      margin: 0,
      color: "#e2e8f0",
      fontSize: "12px",
      lineHeight: "1.5",
      overflowWrap: "break-word"
    },

    button: {
      width: "100%",
      marginTop: "auto",
      padding: "13px",
      border: "1px solid rgba(255,215,0,.3)",
      borderRadius: "10px",
      background: "#172d38",
      color: "#ffd700",
      fontSize: "14px",
      fontWeight: "700",
      cursor: "pointer",
      boxSizing: "border-box",
      textAlign: "center",
      textDecoration: "none",
      display: "block",
      minHeight: "48px"
    },

    disabledButton: {
      width: "100%",
      marginTop: "auto",
      padding: "13px",
      border: "1px solid rgba(255,255,255,.1)",
      borderRadius: "10px",
      background: "rgba(255,255,255,.05)",
      color: "#94a3b8",
      fontSize: "14px",
      fontWeight: "600",
      cursor: "default",
      boxSizing: "border-box",
      textAlign: "center",
      minHeight: "48px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };

  return (
    <div style={styles.page}>
      <Header />

      <main style={styles.main}>

        {/* ==============================
            TITRE
        ============================== */}

        <header style={styles.header}>

          <h1
            style={{
              ...styles.title,
              letterSpacing: "-1px",
              background:
                "linear-gradient(90deg, #ffffff, #ffd700)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              marginTop: 0
            }}
          >
            Mes <span style={{ color: "#ffd700" }}>Projets</span>
          </h1>

          <p style={styles.subtitle}>
            Découvrez mes projets de développement web, de la conception
            d'applications Frontend et Full Stack à la réalisation de
            projets web intégrant des API, React, Node.js, Express et
            MongoDB. Certains projets sont terminés et publiés, tandis
            que d'autres sont actuellement en développement ou en conception.
          </p>

          <div style={styles.line}></div>

        </header>

        {/* ==============================
            PROJETS
        ============================== */}

        <div style={styles.grid}>

          {projects.map((project) => (

            <article
              key={project.id}
              style={styles.card}
            >

              {/* IMAGE */}

              <div style={styles.imageBox}>

                <img
                  src={project.image}
                  alt={`${project.title} - ${project.category}`}
                  style={styles.image}
                  loading="lazy"
                />

                {/* STATUT */}

                <div
                  style={{
                    position: "absolute",
                    top: "15px",
                    right: "15px",
                    maxWidth: "calc(100% - 30px)",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    background: project.statusBg,
                    color: project.statusColor,
                    fontSize: "13px",
                    lineHeight: "1.3",
                    fontWeight: "600",
                    boxSizing: "border-box",
                    overflowWrap: "break-word"
                  }}
                >
                  {project.status}
                </div>

              </div>

              {/* CONTENU */}

              <div style={styles.body}>

                <h2 style={styles.titleCard}>
                  {project.title}
                </h2>

                <p style={styles.category}>
                  {project.category}
                </p>

                <p style={styles.description}>
                  {project.description}
                </p>

                {/* BADGES */}

                <div style={styles.badges}>

                  {project.badges.map((badge, index) => (

                    <span
                      key={index}
                      style={styles.badge}
                    >
                      {badge}
                    </span>

                  ))}

                </div>

                {/* FONCTIONNALITÉS */}

                <h3 style={styles.section}>
                  Fonctionnalités principales :
                </h3>

                <ul style={styles.list}>

                  {project.features.map((feature, index) => (

                    <li key={index}>
                      {feature}
                    </li>

                  ))}

                </ul>

                {/* TECHNOLOGIES */}

                <h3 style={styles.section}>
                  Technologies :
                </h3>

                <div style={styles.techs}>

                  {project.technologies.map((tech, index) => (

                    <span
                      key={index}
                      style={styles.tech}
                    >
                      {tech}
                    </span>

                  ))}

                </div>

                {/* OBJECTIF */}

                <div style={styles.objective}>

                  <span style={styles.objectiveTitle}>
                    Objectif du projet
                  </span>

                  <p style={styles.objectiveText}>
                    {project.objective}
                  </p>

                </div>

                {/* BOUTON */}

                {project.link ? (

                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.button}
                    aria-label={`Voir le projet ${project.title} en ligne`}
                  >
                    Voir le projet en ligne →
                  </a>

                ) : (

                  <div style={styles.disabledButton}>
                    Projet actuellement en développement
                  </div>

                )}

              </div>

            </article>

          ))}

        </div>

      </main>
    </div>
  );
};

export default Projets;

